import { render, staticRenderFns } from "./MonthlyData.vue?vue&type=template&id=edab6744&scoped=true&"
import script from "./MonthlyData.vue?vue&type=script&lang=js&"
export * from "./MonthlyData.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyData.vue?vue&type=style&index=0&id=edab6744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edab6744",
  null
  
)

export default component.exports